var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMustache2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "22mm",
    height: 25.066,
    viewBox: "0 0 22 6.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3b2e29",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.088,
    d: "M20.858 4.118a2.341 2.341 0 01-1.54-.339c-1.07-.657-2.006-1.795-3.043-2.571-1.031-.774-2.16-1.284-3.305-1.2-.509.038-1.5.295-1.969 1.05C10.533.302 9.542.045 9.034.007c-1.146-.084-2.274.426-3.306 1.2-1.037.776-1.973 1.914-3.043 2.571a2.343 2.343 0 01-1.54.339c-.123-.017-1.185-.367-1.142.036.136 1.27 1.404 2.103 2.074 2.334 1.144.395 2.312-.098 3.398-.672C6.55 5.252 7.608 4.65 8.712 4.262c.62-.22 1.779-.363 2.29-1.262.51.9 1.67 1.043 2.29 1.262 1.103.388 2.163.99 3.235 1.554 1.087.574 2.255 1.067 3.4.672.67-.23 1.937-1.065 2.073-2.334.043-.403-1.019-.05-1.142-.036"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMustache2);
export default __webpack_public_path__ + "static/media/mustache2.ba0ea069d549330d5d97cae3c729f5e7.svg";
export { ForwardRef as ReactComponent };